import { render } from "./FlowFormQuestion.vue?vue&type=template&id=0c7b6e72"
import script from "./FlowFormQuestion.vue?vue&type=script&lang=js"
export * from "./FlowFormQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/Users/biwabits/Documents/ProjectDev/yayasan-ahmadyanibinjai/form-ppdb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__